import { useEffect, useState } from 'react';

function useCsrfToken() {
    const [csrfToken, setCsrfToken] = useState('');

    useEffect(() => {
        // Ottieni il token CSRF dal backend
        fetch('https://api.huberway.com/psico-202405/api/csrf-token')
            .then(response => response.json())
            .then(data => setCsrfToken(data.csrf_token))
            .catch(error => console.error('Errore nel recupero del CSRF token:', error));
    }, []);

    return csrfToken;
}

export default useCsrfToken;
